import { notificationMiddleWare } from "utils/NotificationMiddleWare";
import { apiBase } from "APIs/index";

export const AI_getHandoverEmpList = apiBase.createInstance({
  endpoint: "/get_handover_emp_list/{id}",
  method: "get",
  reducer: "handoverReducer",
  key: "id",
  reduxKey: "getHandoverData",
  action: "GET_HANDOVER_EMP_LIST",
  onSuccess: (data) => data.data,
});
export const AI_getAllHandoverList = apiBase.createInstance({
  endpoint: "/get_all_handover_emp_list",
  method: "get",
  reducer: "handoverReducer",
  key: "id",
  reduxKey: "getAllHandoverData",
  action: "GET_ALL_HANDOVER_LIST",
  onSuccess: (data) => data.data,
});

export const AI_addHandover = apiBase.createInstance({
  endpoint: "/create_handover_emp_notes/{id}",
  method: "post",
  reducer: "handoverReducer",
  reduxKey: "addHandoverData",
  action: "ADD_HANDOVER",
  // middleware : notificationMiddleWare,
  onSuccess: (data) => data.data,
});
export const AI_updateHandover = apiBase.createInstance({
  endpoint: "/update_handover_emp_notes/{id}",
  method: "put",
  reducer: "handoverReducer",
  reduxKey: "updateHandoverData",
  action: "UPDATE_HANDOVER",
  // middleware : notificationMiddleWare,
  onSuccess: (data) => data.data,
});

export const AI_uploadHandoverFiles = apiBase.createInstance({
  endpoint: "/upload_handover_file/{id}",
  method: "put",
  reducer: "handoverReducer",
  reduxKey: "uploadHandoverFile",
  action: "UPLOAD_HANDOVER_FILE",
  // middleware: notificationMiddleWare,
  // onSuccess: (data) => {
  //   AI_getBoards.updateAction(data.board);
  // },
});
export const AI_deleteHandoverFiles = apiBase.createInstance({
  endpoint: "/delete_handover_file/{id}",
  method: "put",
  reducer: "handoverReducer",
  reduxKey: "deleteHandoverFile",
  action: "DELETE_HANDOVER_FILE",
  // middleware: notificationMiddleWare,
  // onSuccess: (data) => {
  //   AI_getBoards.updateAction(data.board);
  // },
});